// src/components/ProtectedRoute.js
import React, { useState, useEffect } from "react";
import { useLocation, Navigate } from "react-router";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [isTokenChecked, setIsTokenChecked] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get("token");

    if (tokenFromUrl) {
      localStorage.setItem("isaacToken", tokenFromUrl);
      // Clean the URL by removing the token
      const url = new URL(window.location.href);
      url.searchParams.delete("token");
      window.history.replaceState({}, document.title, url.pathname + url.search);
    }
    setIsTokenChecked(true);
  }, [location.search]);

  if (!isTokenChecked) {
    // While checking for token in URL, don't render children yet
    return null;
  }

  const token = localStorage.getItem("isaacToken");

  if (!token || token === "null" || token === "undefined") {
    // No token found, redirect to login
    // Store the attempted path to redirect back after login
    const returnTo = location.pathname + location.search;
    localStorage.setItem('returnTo', returnTo);
    return <Navigate to="/login" />;
  }

  try {
    const { exp } = JSON.parse(atob(token.split(".")[1]));
    if (Date.now() >= exp * 1000) {
      // Token is expired
      console.log("Expired Token");
      localStorage.removeItem("isaacToken");
      const returnTo = location.pathname + location.search;
      localStorage.setItem('returnTo', returnTo);
      return <Navigate to="/login" />;
    }
  } catch (e) {
    // Token is invalid
    console.log("Invalid Token Format");
    localStorage.removeItem("isaacToken");
    const returnTo = location.pathname + location.search;
    localStorage.setItem('returnTo', returnTo);
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;

